import { arrayOf, Schema } from 'normalizr';

import { CAMPAIGN_SCHEMA } from '../../campaign/schemas';


export const SITE_SCHEMA = new Schema(
  'sites'
);

SITE_SCHEMA.define({
  campaign: CAMPAIGN_SCHEMA,
});

export const SITES_SCHEMA = {
  items: arrayOf(SITE_SCHEMA),
};
